// extracted by mini-css-extract-plugin
export default {"transWrp":"transaction_transWrp__1yjUO","tabWrp":"transaction_tabWrp__HoZpA","dateWrapper":"transaction_dateWrapper__4dC0Q"};